import { useIntl } from "react-intl"
import { CrudProvider } from "../../../../services/loggedin/CrudContext"
import { ChartsComponent } from "../../../parts/crud/Charts"
import { getBaseBarChartOptions } from "../../../parts/crud/Types"
import moment from "moment"
import { useState, useEffect } from "react"

export const WidgetUserManagedEvents = (props:any) => {
  const intl=useIntl()
  const days = props && props.days ? props.days : 7
 let params: any = {
    intl,
    title: intl.formatMessage({id: 'MENU.OPERATION_RANKING.USER_MANAGED_EVENTS'}),
    subtitle: intl.formatMessage({id: 'GENERIC.X_GIORNI_PRECEDENTI'}).replace('{x}', days) ,
    yAxisTitle: intl.formatMessage({id: 'OPERATION_RANKING.USER_MANAGED_EVENTS.Y_AXIS'}),
    pointFormat:
      '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}' +
      intl.formatMessage({id: 'OPERATION_RANKING.USER_MANAGED_EVENTS.EVENTS'}) +
      '</b><br/>',
  }
  let baseChartOptions = {...getBaseBarChartOptions(params)}

  const [filterData, setFilterData] = useState<any>({});
    
      useEffect(() => {
        const newFilterData =   {
          server:"all",
       
          tz: new Date().getTimezoneOffset(),
          date_range:{
            start:moment().subtract(days, 'days'),
            end:moment(),
          }
        }
        setFilterData(newFilterData);
      }, [days]); 
  /*
  const filterData = {
      server:"all",
   
      tz: new Date().getTimezoneOffset(),
      date_range:{
        start:moment().subtract(days, 'days'),
        end:moment(),
      }
    }
      */
    if(!filterData || Object.keys(filterData).length===0){
      return <></>
    }
 return (
    <>
      <CrudProvider api='operation-ranking/user-managed-events'>
        <ChartsComponent disableError={true} filterData={filterData} chartOnly='true' baseChartOptions={baseChartOptions}></ChartsComponent>
      </CrudProvider>
    </>
  )
  
}